import { AxiosResponse } from "axios";
import { ActionFunction, redirect } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { backendApi } from "../../api";

export const action: ActionFunction = async ({ request }) => {
  const data = Object.fromEntries(await request.formData());
  if (!("confirmationToken" in data) || !data.confirmationToken) {
    enqueueSnackbar("Missing Token", { variant: "error" });
    return redirect("/auth/login");
  }
  try {
    const response: AxiosResponse = await backendApi({
      url: "/users/verify-email",
      method: "POST",
      data: { email_token: data.confirmationToken },
    });
    if (response.status === 200) {
      enqueueSnackbar("Email verified, you may now login!", {
        variant: "success",
      });
    } else {
      enqueueSnackbar("Token Expired or invalid", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Token Expired or invalid", { variant: "error" });
  }
  return redirect("/auth/login");
};
